import type { ReactNode } from 'react';

/**
 * One row of the Review summary — label, current value, and an Edit that jumps
 * back to the owning step (§2.11 #41).
 *
 * `empty` is the italic fallback ("Every domain"), which says what NO filter
 * means rather than leaving the row blank — an empty row reads as a bug, and
 * "every domain" is a meaningfully different session from one domain.
 */
export function ReviewRow({
  label,
  empty,
  onEdit,
  children,
}: {
  label: string;
  empty: string | null;
  onEdit: () => void;
  children?: ReactNode;
}) {
  // ONE `div` between the `dl` and its `dt`/`dd`, which is the most the spec
  // allows. The row used to nest them two divs deep so the Edit button could
  // sit beside the pair, and axe reported `dlitem` — the list announced as a
  // description list containing no described terms. The button moves inside
  // the `dd` instead, which also lines it up with the value it edits rather
  // than with the label.
  return (
    <div className='px-4 py-3'>
      <dt className='mb-1.5 text-xs font-semibold text-muted-foreground'>
        {label}
      </dt>
      <dd className='flex items-start justify-between gap-4'>
        <div className='min-w-0 flex-1'>
          {empty ? (
            <span className='text-sm text-muted-foreground'>{empty}</span>
          ) : (
            children
          )}
        </div>
        <button
          type='button'
          onClick={onEdit}
          className='tap-target flex-shrink-0 text-xs font-medium text-muted-foreground underline-offset-2 hover:text-foreground hover:underline max-sm:text-sm max-sm:text-foreground'
        >
          Edit
        </button>
      </dd>
    </div>
  );
}
